var map = {
	"./404.png": "./src/assets/images/404.png",
	"./about/about-bg-dots.png": "./src/assets/images/about/about-bg-dots.png",
	"./about/about-bg-shape.png": "./src/assets/images/about/about-bg-shape.png",
	"./about/about-circle-dots.png": "./src/assets/images/about/about-circle-dots.png",
	"./about/about-eight-bg.png": "./src/assets/images/about/about-eight-bg.png",
	"./about/about-eight-content-bg.jpg": "./src/assets/images/about/about-eight-content-bg.jpg",
	"./about/about-eight1.jpg": "./src/assets/images/about/about-eight1.jpg",
	"./about/about-eight2.jpg": "./src/assets/images/about/about-eight2.jpg",
	"./about/about-five-two.jpg": "./src/assets/images/about/about-five-two.jpg",
	"./about/about-five.jpg": "./src/assets/images/about/about-five.jpg",
	"./about/about-four-2.jpg": "./src/assets/images/about/about-four-2.jpg",
	"./about/about-four-bg-shape.png": "./src/assets/images/about/about-four-bg-shape.png",
	"./about/about-four.jpg": "./src/assets/images/about/about-four.jpg",
	"./about/about-graph.png": "./src/assets/images/about/about-graph.png",
	"./about/about-seven.png": "./src/assets/images/about/about-seven.png",
	"./about/about-six.png": "./src/assets/images/about/about-six.png",
	"./about/about-tab.png": "./src/assets/images/about/about-tab.png",
	"./about/about-three-1.jpg": "./src/assets/images/about/about-three-1.jpg",
	"./about/about-three-2.jpg": "./src/assets/images/about/about-three-2.jpg",
	"./about/about-two.jpg": "./src/assets/images/about/about-two.jpg",
	"./about/about.png": "./src/assets/images/about/about.png",
	"./about/co-work-black.svg": "./src/assets/images/about/co-work-black.svg",
	"./about/co-work.svg": "./src/assets/images/about/co-work.svg",
	"./about/customization-1.png": "./src/assets/images/about/customization-1.png",
	"./about/customization2.png": "./src/assets/images/about/customization2.png",
	"./about/software_engineer-black.svg": "./src/assets/images/about/software_engineer-black.svg",
	"./about/software_engineer.svg": "./src/assets/images/about/software_engineer.svg",
	"./about/solution-place.png": "./src/assets/images/about/solution-place.png",
	"./actions/action1.jpg": "./src/assets/images/actions/action1.jpg",
	"./actions/action2.jpg": "./src/assets/images/actions/action2.jpg",
	"./actions/action3.jpg": "./src/assets/images/actions/action3.jpg",
	"./actions/action4.jpg": "./src/assets/images/actions/action4.jpg",
	"./actions/author1.jpg": "./src/assets/images/actions/author1.jpg",
	"./actions/author2.jpg": "./src/assets/images/actions/author2.jpg",
	"./actions/author3.jpg": "./src/assets/images/actions/author3.jpg",
	"./actions/author4.jpg": "./src/assets/images/actions/author4.jpg",
	"./actions/collection1.jpg": "./src/assets/images/actions/collection1.jpg",
	"./actions/collection2.jpg": "./src/assets/images/actions/collection2.jpg",
	"./actions/collection3.jpg": "./src/assets/images/actions/collection3.jpg",
	"./actions/collection4.jpg": "./src/assets/images/actions/collection4.jpg",
	"./actions/collection5.jpg": "./src/assets/images/actions/collection5.jpg",
	"./actions/collection6.jpg": "./src/assets/images/actions/collection6.jpg",
	"./actions/collection7.jpg": "./src/assets/images/actions/collection7.jpg",
	"./actions/collection8.jpg": "./src/assets/images/actions/collection8.jpg",
	"./adwords.jpg": "./src/assets/images/adwords.jpg",
	"./background/call-action-bg.png": "./src/assets/images/background/call-action-bg.png",
	"./background/call-action-three-bg.jpg": "./src/assets/images/background/call-action-three-bg.jpg",
	"./background/counter-bg.png": "./src/assets/images/background/counter-bg.png",
	"./background/footer-bg.png": "./src/assets/images/background/footer-bg.png",
	"./background/footer-call-action-bg.png": "./src/assets/images/background/footer-call-action-bg.png",
	"./background/price-bg-balls.png": "./src/assets/images/background/price-bg-balls.png",
	"./background/price-five-bg.png": "./src/assets/images/background/price-five-bg.png",
	"./background/pricing-bg.png": "./src/assets/images/background/pricing-bg.png",
	"./background/pricing-seven-bg.png": "./src/assets/images/background/pricing-seven-bg.png",
	"./background/progress-bg-line.png": "./src/assets/images/background/progress-bg-line.png",
	"./background/progress.png": "./src/assets/images/background/progress.png",
	"./background/services.png": "./src/assets/images/background/services.png",
	"./background/subscribe-bg.png": "./src/assets/images/background/subscribe-bg.png",
	"./background/work-progress.jpg": "./src/assets/images/background/work-progress.jpg",
	"./banner.png": "./src/assets/images/banner.png",
	"./banner1.jpg": "./src/assets/images/banner1.jpg",
	"./banner2.png": "./src/assets/images/banner2.png",
	"./banner3.png": "./src/assets/images/banner3.png",
	"./call-action/call-action-bg.png": "./src/assets/images/call-action/call-action-bg.png",
	"./call-action/call-action-right.png": "./src/assets/images/call-action/call-action-right.png",
	"./categories/category1.png": "./src/assets/images/categories/category1.png",
	"./categories/category10.png": "./src/assets/images/categories/category10.png",
	"./categories/category2.png": "./src/assets/images/categories/category2.png",
	"./categories/category3.png": "./src/assets/images/categories/category3.png",
	"./categories/category4.png": "./src/assets/images/categories/category4.png",
	"./categories/category5.png": "./src/assets/images/categories/category5.png",
	"./categories/category6.png": "./src/assets/images/categories/category6.png",
	"./categories/category7.png": "./src/assets/images/categories/category7.png",
	"./categories/category8.png": "./src/assets/images/categories/category8.png",
	"./categories/category9.png": "./src/assets/images/categories/category9.png",
	"./client-logo/client-logo-1.png": "./src/assets/images/client-logo/client-logo-1.png",
	"./client-logo/client-logo-10.png": "./src/assets/images/client-logo/client-logo-10.png",
	"./client-logo/client-logo-11.png": "./src/assets/images/client-logo/client-logo-11.png",
	"./client-logo/client-logo-12.png": "./src/assets/images/client-logo/client-logo-12.png",
	"./client-logo/client-logo-13.png": "./src/assets/images/client-logo/client-logo-13.png",
	"./client-logo/client-logo-14.png": "./src/assets/images/client-logo/client-logo-14.png",
	"./client-logo/client-logo-15.png": "./src/assets/images/client-logo/client-logo-15.png",
	"./client-logo/client-logo-16.png": "./src/assets/images/client-logo/client-logo-16.png",
	"./client-logo/client-logo-2.png": "./src/assets/images/client-logo/client-logo-2.png",
	"./client-logo/client-logo-3.png": "./src/assets/images/client-logo/client-logo-3.png",
	"./client-logo/client-logo-4.png": "./src/assets/images/client-logo/client-logo-4.png",
	"./client-logo/client-logo-5.png": "./src/assets/images/client-logo/client-logo-5.png",
	"./client-logo/client-logo-6.png": "./src/assets/images/client-logo/client-logo-6.png",
	"./client-logo/client-logo-7.png": "./src/assets/images/client-logo/client-logo-7.png",
	"./client-logo/client-logo-8.png": "./src/assets/images/client-logo/client-logo-8.png",
	"./client-logo/client-logo-9.png": "./src/assets/images/client-logo/client-logo-9.png",
	"./contact/contact-bg.jpg": "./src/assets/images/contact/contact-bg.jpg",
	"./contact/contact-page.jpg": "./src/assets/images/contact/contact-page.jpg",
	"./contact/contact.svg": "./src/assets/images/contact/contact.svg",
	"./contact/home-two.jpg": "./src/assets/images/contact/home-two.jpg",
	"./counter/counter-bg-section.jpg": "./src/assets/images/counter/counter-bg-section.jpg",
	"./counter/counter-bg.jpg": "./src/assets/images/counter/counter-bg.jpg",
	"./counter/icon1.png": "./src/assets/images/counter/icon1.png",
	"./counter/icon2.png": "./src/assets/images/counter/icon2.png",
	"./counter/icon3.png": "./src/assets/images/counter/icon3.png",
	"./favicon.png": "./src/assets/images/favicon.png",
	"./feature/feature-bg.jpg": "./src/assets/images/feature/feature-bg.jpg",
	"./feature/icon1.png": "./src/assets/images/feature/icon1.png",
	"./feature/icon2.png": "./src/assets/images/feature/icon2.png",
	"./feature/icon3.png": "./src/assets/images/feature/icon3.png",
	"./footer/footer-bg-dots.png": "./src/assets/images/footer/footer-bg-dots.png",
	"./footer/footer-bg-map.png": "./src/assets/images/footer/footer-bg-map.png",
	"./footer/footer-bg.png": "./src/assets/images/footer/footer-bg.png",
	"./footer/footer-call-action.png": "./src/assets/images/footer/footer-call-action.png",
	"./gallery/gallery-1.jpg": "./src/assets/images/gallery/gallery-1.jpg",
	"./gallery/gallery-2.jpg": "./src/assets/images/gallery/gallery-2.jpg",
	"./gallery/gallery-3.jpg": "./src/assets/images/gallery/gallery-3.jpg",
	"./gallery/gallery-4.jpg": "./src/assets/images/gallery/gallery-4.jpg",
	"./gallery/gallery-bg.png": "./src/assets/images/gallery/gallery-bg.png",
	"./gallery/gallery-five-1.jpg": "./src/assets/images/gallery/gallery-five-1.jpg",
	"./gallery/gallery-five-2.jpg": "./src/assets/images/gallery/gallery-five-2.jpg",
	"./gallery/gallery-five-3.jpg": "./src/assets/images/gallery/gallery-five-3.jpg",
	"./gallery/gallery-five-4.jpg": "./src/assets/images/gallery/gallery-five-4.jpg",
	"./gallery/gallery-four-1.jpg": "./src/assets/images/gallery/gallery-four-1.jpg",
	"./gallery/gallery-four-2.jpg": "./src/assets/images/gallery/gallery-four-2.jpg",
	"./gallery/gallery-four-3.jpg": "./src/assets/images/gallery/gallery-four-3.jpg",
	"./gallery/gallery-four-4.jpg": "./src/assets/images/gallery/gallery-four-4.jpg",
	"./gallery/gallery-four-5.jpg": "./src/assets/images/gallery/gallery-four-5.jpg",
	"./gallery/gallery-four-6.jpg": "./src/assets/images/gallery/gallery-four-6.jpg",
	"./gallery/gallery-four-7.jpg": "./src/assets/images/gallery/gallery-four-7.jpg",
	"./gallery/gallery-four-8.jpg": "./src/assets/images/gallery/gallery-four-8.jpg",
	"./gallery/gallery-three-1.jpg": "./src/assets/images/gallery/gallery-three-1.jpg",
	"./gallery/gallery-three-2.jpg": "./src/assets/images/gallery/gallery-three-2.jpg",
	"./gallery/gallery-three-3.jpg": "./src/assets/images/gallery/gallery-three-3.jpg",
	"./gallery/gallery-three-4.jpg": "./src/assets/images/gallery/gallery-three-4.jpg",
	"./gallery/gallery-three-5.jpg": "./src/assets/images/gallery/gallery-three-5.jpg",
	"./gallery/gallery-three-6.jpg": "./src/assets/images/gallery/gallery-three-6.jpg",
	"./gallery/gallery-three-7.jpg": "./src/assets/images/gallery/gallery-three-7.jpg",
	"./gallery/gallery-three-8.jpg": "./src/assets/images/gallery/gallery-three-8.jpg",
	"./gallery/gallery-three-9.jpg": "./src/assets/images/gallery/gallery-three-9.jpg",
	"./gallery/gallery-two-1.jpg": "./src/assets/images/gallery/gallery-two-1.jpg",
	"./gallery/gallery-two-2.jpg": "./src/assets/images/gallery/gallery-two-2.jpg",
	"./gallery/gallery-two-3.jpg": "./src/assets/images/gallery/gallery-two-3.jpg",
	"./gallery/portfolio-details.jpg": "./src/assets/images/gallery/portfolio-details.jpg",
	"./gallery/portfolio-middle-1.jpg": "./src/assets/images/gallery/portfolio-middle-1.jpg",
	"./gallery/portfolio-middle-2.jpg": "./src/assets/images/gallery/portfolio-middle-2.jpg",
	"./gallery/project1.jpg": "./src/assets/images/gallery/project1.jpg",
	"./gallery/project2.jpg": "./src/assets/images/gallery/project2.jpg",
	"./gallery/project3.jpg": "./src/assets/images/gallery/project3.jpg",
	"./gallery/project4.jpg": "./src/assets/images/gallery/project4.jpg",
	"./graphicdesign.jpg": "./src/assets/images/graphicdesign.jpg",
	"./hero/hero-eight.png": "./src/assets/images/hero/hero-eight.png",
	"./hero/hero-five.jpg": "./src/assets/images/hero/hero-five.jpg",
	"./hero/hero-four-shape.png": "./src/assets/images/hero/hero-four-shape.png",
	"./hero/hero-four.jpg": "./src/assets/images/hero/hero-four.jpg",
	"./hero/hero-icon1.png": "./src/assets/images/hero/hero-icon1.png",
	"./hero/hero-icon2.png": "./src/assets/images/hero/hero-icon2.png",
	"./hero/hero-icon3.png": "./src/assets/images/hero/hero-icon3.png",
	"./hero/hero-one.jpg": "./src/assets/images/hero/hero-one.jpg",
	"./hero/hero-seven-bg.png": "./src/assets/images/hero/hero-seven-bg.png",
	"./hero/hero-seven-right-image.png": "./src/assets/images/hero/hero-seven-right-image.png",
	"./hero/hero-six-1.png": "./src/assets/images/hero/hero-six-1.png",
	"./hero/hero-six-2.png": "./src/assets/images/hero/hero-six-2.png",
	"./hero/hero-six-3.png": "./src/assets/images/hero/hero-six-3.png",
	"./hero/hero-six-ellipse.png": "./src/assets/images/hero/hero-six-ellipse.png",
	"./hero/hero-three.jpg": "./src/assets/images/hero/hero-three.jpg",
	"./hero/hero-two.jpg": "./src/assets/images/hero/hero-two.jpg",
	"./logos/logo--.png": "./src/assets/images/logos/logo--.png",
	"./logos/logo-black.png": "./src/assets/images/logos/logo-black.png",
	"./logos/logo-circle.png": "./src/assets/images/logos/logo-circle.png",
	"./logos/logo-footer-three.png": "./src/assets/images/logos/logo-footer-three.png",
	"./logos/logo-footer-two.png": "./src/assets/images/logos/logo-footer-two.png",
	"./logos/logo-footer.png": "./src/assets/images/logos/logo-footer.png",
	"./logos/logo-three.png": "./src/assets/images/logos/logo-three.png",
	"./logos/logo-two.png": "./src/assets/images/logos/logo-two.png",
	"./logos/logo-white-three.png": "./src/assets/images/logos/logo-white-three.png",
	"./logos/logo-white-two.png": "./src/assets/images/logos/logo-white-two.png",
	"./logos/logo-white.png": "./src/assets/images/logos/logo-white.png",
	"./logos/logo.png": "./src/assets/images/logos/logo.png",
	"./mobiledev.jpg": "./src/assets/images/mobiledev.jpg",
	"./news/blog-1.jpg": "./src/assets/images/news/blog-1.jpg",
	"./news/blog-2.jpg": "./src/assets/images/news/blog-2.jpg",
	"./news/blog-five1.jpg": "./src/assets/images/news/blog-five1.jpg",
	"./news/blog-five2.jpg": "./src/assets/images/news/blog-five2.jpg",
	"./news/blog-five3.jpg": "./src/assets/images/news/blog-five3.jpg",
	"./news/blog-standard-1.jpg": "./src/assets/images/news/blog-standard-1.jpg",
	"./news/blog-standard-2.jpg": "./src/assets/images/news/blog-standard-2.jpg",
	"./news/blog-standard-3.jpg": "./src/assets/images/news/blog-standard-3.jpg",
	"./news/call-action-widget.jpg": "./src/assets/images/news/call-action-widget.jpg",
	"./news/comment-author-1.jpg": "./src/assets/images/news/comment-author-1.jpg",
	"./news/comment-author-2.jpg": "./src/assets/images/news/comment-author-2.jpg",
	"./news/comment-author-3.jpg": "./src/assets/images/news/comment-author-3.jpg",
	"./news/footer-widget-1.jpg": "./src/assets/images/news/footer-widget-1.jpg",
	"./news/footer-widget-2.jpg": "./src/assets/images/news/footer-widget-2.jpg",
	"./news/icon1.png": "./src/assets/images/news/icon1.png",
	"./news/icon2.png": "./src/assets/images/news/icon2.png",
	"./news/icon3.png": "./src/assets/images/news/icon3.png",
	"./news/left-image.png": "./src/assets/images/news/left-image.png",
	"./news/news-1.jpg": "./src/assets/images/news/news-1.jpg",
	"./news/news-2.jpg": "./src/assets/images/news/news-2.jpg",
	"./news/news-3.jpg": "./src/assets/images/news/news-3.jpg",
	"./news/news-4.jpg": "./src/assets/images/news/news-4.jpg",
	"./news/news-5.jpg": "./src/assets/images/news/news-5.jpg",
	"./news/news-6.jpg": "./src/assets/images/news/news-6.jpg",
	"./news/news-author-1.jpg": "./src/assets/images/news/news-author-1.jpg",
	"./news/news-author-2.jpg": "./src/assets/images/news/news-author-2.jpg",
	"./news/news-author-3.jpg": "./src/assets/images/news/news-author-3.jpg",
	"./news/news-bg-two.jpg": "./src/assets/images/news/news-bg-two.jpg",
	"./news/news-six1.jpg": "./src/assets/images/news/news-six1.jpg",
	"./news/news-six2.jpg": "./src/assets/images/news/news-six2.jpg",
	"./news/news-six3.jpg": "./src/assets/images/news/news-six3.jpg",
	"./news/news-widget-1.jpg": "./src/assets/images/news/news-widget-1.jpg",
	"./news/news-widget-2.jpg": "./src/assets/images/news/news-widget-2.jpg",
	"./news/news-widget-3.jpg": "./src/assets/images/news/news-widget-3.jpg",
	"./news/protects-bg.png": "./src/assets/images/news/protects-bg.png",
	"./news/ready.jpg": "./src/assets/images/news/ready.jpg",
	"./news/video.jpg": "./src/assets/images/news/video.jpg",
	"./protects/icon1.png": "./src/assets/images/protects/icon1.png",
	"./protects/icon2.png": "./src/assets/images/protects/icon2.png",
	"./protects/icon3.png": "./src/assets/images/protects/icon3.png",
	"./protects/left-image.png": "./src/assets/images/protects/left-image.png",
	"./protects/protects-bg.png": "./src/assets/images/protects/protects-bg.png",
	"./protects/ready.jpg": "./src/assets/images/protects/ready.jpg",
	"./protects/video.jpg": "./src/assets/images/protects/video.jpg",
	"./sallers/saller1.png": "./src/assets/images/sallers/saller1.png",
	"./sallers/saller2.png": "./src/assets/images/sallers/saller2.png",
	"./sallers/saller3.png": "./src/assets/images/sallers/saller3.png",
	"./sallers/saller4.png": "./src/assets/images/sallers/saller4.png",
	"./sallers/saller5.png": "./src/assets/images/sallers/saller5.png",
	"./seo.jpg": "./src/assets/images/seo.jpg",
	"./services/icon1.png": "./src/assets/images/services/icon1.png",
	"./services/icon2.png": "./src/assets/images/services/icon2.png",
	"./services/icon3.png": "./src/assets/images/services/icon3.png",
	"./services/icon4.png": "./src/assets/images/services/icon4.png",
	"./services/service-1.jpg": "./src/assets/images/services/service-1.jpg",
	"./services/service-2.jpg": "./src/assets/images/services/service-2.jpg",
	"./services/service-3.jpg": "./src/assets/images/services/service-3.jpg",
	"./services/service-details.jpg": "./src/assets/images/services/service-details.jpg",
	"./services/service-eight-bg.png": "./src/assets/images/services/service-eight-bg.png",
	"./services/service-five-1.jpg": "./src/assets/images/services/service-five-1.jpg",
	"./services/service-five-2.jpg": "./src/assets/images/services/service-five-2.jpg",
	"./services/service-five-3.jpg": "./src/assets/images/services/service-five-3.jpg",
	"./services/service-five-4.jpg": "./src/assets/images/services/service-five-4.jpg",
	"./services/service-seven1.png": "./src/assets/images/services/service-seven1.png",
	"./services/service-seven2.png": "./src/assets/images/services/service-seven2.png",
	"./services/service-seven3.png": "./src/assets/images/services/service-seven3.png",
	"./shapes/circle.png": "./src/assets/images/shapes/circle.png",
	"./shapes/close.png": "./src/assets/images/shapes/close.png",
	"./shapes/counter-side-line.png": "./src/assets/images/shapes/counter-side-line.png",
	"./shapes/dots.png": "./src/assets/images/shapes/dots.png",
	"./shapes/faq-triangle.png": "./src/assets/images/shapes/faq-triangle.png",
	"./shapes/hero-shape1.png": "./src/assets/images/shapes/hero-shape1.png",
	"./shapes/hero-shape2.png": "./src/assets/images/shapes/hero-shape2.png",
	"./shapes/lines.png": "./src/assets/images/shapes/lines.png",
	"./shapes/service-line.png": "./src/assets/images/shapes/service-line.png",
	"./shapes/service-triangle.png": "./src/assets/images/shapes/service-triangle.png",
	"./shapes/stones.png": "./src/assets/images/shapes/stones.png",
	"./shapes/triangle.png": "./src/assets/images/shapes/triangle.png",
	"./shapes/w-shape.png": "./src/assets/images/shapes/w-shape.png",
	"./shop/preview-1.jpg": "./src/assets/images/shop/preview-1.jpg",
	"./shop/preview-2.jpg": "./src/assets/images/shop/preview-2.jpg",
	"./shop/preview-3.jpg": "./src/assets/images/shop/preview-3.jpg",
	"./shop/preview-4.jpg": "./src/assets/images/shop/preview-4.jpg",
	"./shop/preview-5.jpg": "./src/assets/images/shop/preview-5.jpg",
	"./shop/preview-6.jpg": "./src/assets/images/shop/preview-6.jpg",
	"./shop/product-1.jpg": "./src/assets/images/shop/product-1.jpg",
	"./shop/product-2.jpg": "./src/assets/images/shop/product-2.jpg",
	"./shop/product-3.jpg": "./src/assets/images/shop/product-3.jpg",
	"./shop/product-4.jpg": "./src/assets/images/shop/product-4.jpg",
	"./shop/product-5.jpg": "./src/assets/images/shop/product-5.jpg",
	"./shop/product-6.jpg": "./src/assets/images/shop/product-6.jpg",
	"./shop/product-7.jpg": "./src/assets/images/shop/product-7.jpg",
	"./shop/product-8.jpg": "./src/assets/images/shop/product-8.jpg",
	"./shop/product-9.jpg": "./src/assets/images/shop/product-9.jpg",
	"./shop/reviewer-1.png": "./src/assets/images/shop/reviewer-1.png",
	"./shop/thumb-1.jpg": "./src/assets/images/shop/thumb-1.jpg",
	"./shop/thumb-2.jpg": "./src/assets/images/shop/thumb-2.jpg",
	"./shop/thumb-3.jpg": "./src/assets/images/shop/thumb-3.jpg",
	"./shop/thumb-4.jpg": "./src/assets/images/shop/thumb-4.jpg",
	"./shop/thumb-5.jpg": "./src/assets/images/shop/thumb-5.jpg",
	"./shop/thumb-6.jpg": "./src/assets/images/shop/thumb-6.jpg",
	"./shop/widget-1.jpg": "./src/assets/images/shop/widget-1.jpg",
	"./shop/widget-2.jpg": "./src/assets/images/shop/widget-2.jpg",
	"./shop/widget-3.jpg": "./src/assets/images/shop/widget-3.jpg",
	"./shop/widget-4.jpg": "./src/assets/images/shop/widget-4.jpg",
	"./shop/widget-5.jpg": "./src/assets/images/shop/widget-5.jpg",
	"./slider/slide1.jpg": "./src/assets/images/slider/slide1.jpg",
	"./slider/slide2.jpg": "./src/assets/images/slider/slide2.jpg",
	"./slider/slide3.jpg": "./src/assets/images/slider/slide3.jpg",
	"./team/Abrar Ahmed.jpeg": "./src/assets/images/team/Abrar Ahmed.jpeg",
	"./team/Ahmed Jamshed.jpeg": "./src/assets/images/team/Ahmed Jamshed.jpeg",
	"./team/Ahmed Shaikh.jpeg": "./src/assets/images/team/Ahmed Shaikh.jpeg",
	"./team/Asad Waleed.jpg": "./src/assets/images/team/Asad Waleed.jpg",
	"./team/Hafsa Arshad.jpeg": "./src/assets/images/team/Hafsa Arshad.jpeg",
	"./team/Hassam Shaikh.jpg": "./src/assets/images/team/Hassam Shaikh.jpg",
	"./team/Ibad Shaikh.jpg": "./src/assets/images/team/Ibad Shaikh.jpg",
	"./team/Manahil Sikandar.jpeg": "./src/assets/images/team/Manahil Sikandar.jpeg",
	"./team/Mazhar Haroon.jpeg": "./src/assets/images/team/Mazhar Haroon.jpeg",
	"./team/Minahil Waqar.jpeg": "./src/assets/images/team/Minahil Waqar.jpeg",
	"./team/Muneeb Butt.jpg": "./src/assets/images/team/Muneeb Butt.jpg",
	"./team/Nadeem Safi.jpeg": "./src/assets/images/team/Nadeem Safi.jpeg",
	"./team/Naureen Saleem.jpeg": "./src/assets/images/team/Naureen Saleem.jpeg",
	"./team/QSTL Team Details.pdf": "./src/assets/images/team/QSTL Team Details.pdf",
	"./team/Sherwin Samuel.jpeg": "./src/assets/images/team/Sherwin Samuel.jpeg",
	"./team/Zaheer Ahmed.jpeg": "./src/assets/images/team/Zaheer Ahmed.jpeg",
	"./team/Zohaib Ali.PNG": "./src/assets/images/team/Zohaib Ali.PNG",
	"./testimonials/tai1.png": "./src/assets/images/testimonials/tai1.png",
	"./testimonials/tai2.png": "./src/assets/images/testimonials/tai2.png",
	"./testimonials/tai3.png": "./src/assets/images/testimonials/tai3.png",
	"./testimonials/tai4.png": "./src/assets/images/testimonials/tai4.png",
	"./testimonials/tai5.png": "./src/assets/images/testimonials/tai5.png",
	"./testimonials/testi-author-1.jpg": "./src/assets/images/testimonials/testi-author-1.jpg",
	"./testimonials/testi-author-2.jpg": "./src/assets/images/testimonials/testi-author-2.jpg",
	"./testimonials/testi-author-3.jpg": "./src/assets/images/testimonials/testi-author-3.jpg",
	"./testimonials/testi-author-4.jpg": "./src/assets/images/testimonials/testi-author-4.jpg",
	"./testimonials/testi-five-author.jpg": "./src/assets/images/testimonials/testi-five-author.jpg",
	"./testimonials/testi-four-author-1.png": "./src/assets/images/testimonials/testi-four-author-1.png",
	"./testimonials/testi-four-author-2.png": "./src/assets/images/testimonials/testi-four-author-2.png",
	"./testimonials/testi-four-author-3.png": "./src/assets/images/testimonials/testi-four-author-3.png",
	"./testimonials/testi-six-author-1.png": "./src/assets/images/testimonials/testi-six-author-1.png",
	"./testimonials/testi-six-author-2.png": "./src/assets/images/testimonials/testi-six-author-2.png",
	"./testimonials/testimonial-five-bg.jpg": "./src/assets/images/testimonials/testimonial-five-bg.jpg",
	"./testimonials/testimonial-three.jpg": "./src/assets/images/testimonials/testimonial-three.jpg",
	"./testimonials/testimonial-two.jpg": "./src/assets/images/testimonials/testimonial-two.jpg",
	"./webdev.jpg": "./src/assets/images/webdev.jpg",
	"./work-progress/icon-1.png": "./src/assets/images/work-progress/icon-1.png",
	"./work-progress/icon-2.png": "./src/assets/images/work-progress/icon-2.png",
	"./work-progress/icon-3.png": "./src/assets/images/work-progress/icon-3.png",
	"./work-progress/icon-4.png": "./src/assets/images/work-progress/icon-4.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*$";